/*! Custom Scipts */
$(document).ready(function () {
    // Form Edit view
    $(".edit-mode-btn").click(function () {
        var dataedit = $(this).attr("data-edit");
        $(".my-details-form").addClass("active");
        $("." + dataedit).slideToggle().addClass("activeform");
        $(this).parents(".form-view").addClass("hidden");
        return false;
    });
    $(".update-edit").click(function () {
        $(".my-details-form").removeClass("active");
        $(".activeform").removeClass("activeform").slideToggle();
        $(".form-view").removeClass("hidden");
        return false;
    });
    // Category Slider
    if ($(".category-slider").length > 0) {
        $(".category-slider").slick({
            dots: false,
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            prevArrow: $(".prevArrow"),
            nextArrow: $(".nextArrow")
        });
    }
    // FAQ
    $(".questions h6 a").click(function() {
        $('html, body').animate({
            scrollTop: $(this.hash).offset().top-30
        }, 800);
        return false;
    });

    // Search Bar
    var source = new Bloodhound({
        datumTokenizer: Bloodhound.tokenizers.whitespace,
        queryTokenizer: Bloodhound.tokenizers.whitespace,
        remote: {
            url: '/api/search/autocomplete?term=*',
            wildcard: '*',
            rateLimitWait: 500,
        }
    });
    $('.searchbox .typeahead').typeahead({
        hint: true,
        minLength: 3,
    }, {
        name: 'source',
        source: source,
        display: 'label',
        templates: {
            suggestion: function (data) {
                return '<div  class="tt-suggestion tt-selectable">'+
                    '<a href="'+ data.url +'">' +
                    '<img src="'+ data.image +'" width="24">' +
                    '<span>' + data.label + '</span></a></div>';
            }
        }
    });
});



// WEBPACK FOOTER //
// ./static/js/scripts.js